<nav class="navbar">
  <div class="navbar-content">
    <button
      class="navbar-toggler d-lg-none"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvas-admin-menu"
      aria-controls="offcanvas-admin-menu"
      >
      <fa-icon [icon]="faBars"></fa-icon>
    </button>

    <div class="header-content">
      @if (displayBreadcrumbs) {
        <app-header-menu-breadcrumbs></app-header-menu-breadcrumbs>
      }
    </div>
  </div>

  <ul class="navbar-nav">
    @if (currentUser && hasAclAccess(EnumAcl.usersViewEventLogs)) {
      <li class="nav-item">
        <app-header-menu-current-url-logs
          [currentRoute]="currentRoute"
          [currentUserId]="currentUser.id"
        ></app-header-menu-current-url-logs>
      </li>
    }
    <li class="nav-item">
      @if (currentUser) {
        <button
          class="nav-link btn-notification"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          >
          <fa-icon [icon]="faBell"></fa-icon>
          @if (unreadCount > 0) {
            <span class="count-pill">
              {{ unreadCount }}
              <span class="visually-hidden">notifications non-lus</span>
            </span>
          }
        </button>
      }
      <div class="dropdown-menu dropdown-menu-end">
        @if (loadingNotifications) {
          <ul
            class="list-group list-group-flush notifications-list"
            >
            @for (number of [].constructor(5); track $index) {
              <li
                class="list-group-item placeholder-glow"
                >
                <div class="placeholder w-100"></div>
              </li>
            }
          </ul>
        }
        @if (!loadingNotifications) {
          <ul
            class="list-group list-group-flush notifications-list"
            >
            @if (!notifications.length) {
              <li
                class="list-group-item list-group-item-warning text-center"
                [innerText]="'GENERAL.NO_NOTIFICATIONS' | translate"
              ></li>
            }
            @for (notification of notifications; track notification.id) {
              <button
                type="button"
                class="list-group-item list-group-item-action"
                [class.read]="notification.read"
                (click)="openNotification(notification)"
                >
                <fa-icon [icon]="notification.icon"></fa-icon>
                <div class="notification-content">
                  <strong [innerText]="notification.title"></strong>
                  <div [innerHTML]="notification.message"></div>
                  <div
                    class="notification-date"
                    [innerText]="notification.created | date : 'dd/MM/yyyy HH:mm'"
                  ></div>
                </div>
              </button>
            }
          </ul>
        }
      </div>
    </li>
    <li class="nav-item dropdown">
      @if (currentUser) {
        <button
          class="nav-link btn-user"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          >
          <fa-icon [icon]="faCircleUser"></fa-icon>
        </button>
      }
      <ul class="dropdown-menu dropdown-menu-end">
        @if (currentUser) {
          <li>
            <a class="dropdown-item" routerLink="/admin/my-account">
              <fa-icon [icon]="faCircleUser"></fa-icon>
              {{ getUserFullname(currentUser) }}
            </a>
          </li>
        }
        <li><hr class="dropdown-divider" /></li>
        <li>
          <a class="dropdown-item" routerLink="/admin/my-account">
            <fa-icon [icon]="faUser"></fa-icon> {{ 'USERS.PROFILE' | translate }}</a
            >
          </li>
          <li><hr class="dropdown-divider" /></li>
          <li>
            <button type="button" class="dropdown-item" (click)="signOut()">
              <fa-icon [icon]="faPowerOff"></fa-icon>
              {{ 'GENERAL.LOGOUT' | translate }}
            </button>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
